export class DrawerConfig {
  id;
  result;
  data;
  close;
  constructor(data, id) {
    this.id = id || globalThis.crypto.randomUUID();
    this.data = data;
    this.result = new Promise((resolve) => {
      this.close = () => resolve(true);
    });
  }
}
